import { request } from '@/common/utils/request'
import { getBDCountry, getBDTimezone } from '@/common/utils/i18n'
export const getCommonParams = function () {
  return {
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}
export const handleParams = function (pendingParams = {}, hasType) {
  const pendedParams = {
    lat: pendingParams.lat + '',
    lng: pendingParams.lng + '',
    status: pendingParams.status.map(num => num.toString()),
    bizCityId: pendingParams.cityId,
  }

  if (hasType) {
    pendedParams.type = pendingParams.type.map(num => num.toString())
  }
  const commonparams = getCommonParams()
  const allParams = Object.assign({}, pendingParams, commonparams, pendedParams)
  delete allParams.cityId
  return allParams
}

export async function getList(params = {}) {
  const allParams = handleParams(params, true)
  return request
    .post({
      url: 'feidian.gas.bizopp.bdapp.getList',
      data: allParams,
    })
    .then(res => {
      return res.data
    })
}

export function getAreaList(params) {
  const allParams = handleParams(params, false)
  return request
    .post({
      url: 'feidian.bdapp.area.getList',
      data: allParams,
    })
    .then(res => {
      return res.data
    })
}

/** 经营数据 */
export function getOperationData(params) {
  return request
    .get({
      url: 'feidian.gas.bizopp.bdapp.getOperationData',
      params,
    })
    .then(res => {
      return res.data
    })
}
/** 实时价格 */
export function getPriceData(params) {
  return request
    .get({
      url: 'feidian.gas.bizopp.bdapp.getRealtimePrice',
      params,
    })
    .then(res => {
      return res.data
    })
}
/** 零售价格 */
export function getMarketPrice(params) {
  return request
    .get({
      url: 'feidian.gas.bizopp.bdapp.getMarketPrice',
      params,
    })
    .then(res => {
      return res.data
    })
}
/** 历史价格 */
export function getHistoryPrice(params) {
  return request
    .get({
      url: 'feidian.gas.bizopp.bdapp.getHistoryPrice',
      params,
    })
    .then(res => {
      return res.data
    })
}
